import { phpRequest } from "./phpRequest";

export const getUnsubscribeCompanyAPI = (
  subscribeServiceId,
  page,
  record,
  orderByColumn,
  orderByDesc
) => {
  return phpRequest.post("/subscribe/unsubscribe-companies", {
    subscribe_service_id: subscribeServiceId,
    order_by_column: orderByColumn,
    order_by_desc: orderByDesc,
    page: page,
    record: record,
  });
};
